/** 与 actionow / ai.xhcjai.com 对齐的品牌资源（仅 logo 与命名，不改布局）。 */
export const BRAND_NAME = '宸镜AI'

export const BRAND_SITE_TITLE = '宸镜AI - AI创作平台'

export const BRAND_ADMIN_TITLE = '宸镜AI · 管理后台'

export const BRAND_LOGO_VERSION = '20260824brand'

/** 深色背景（管理侧栏等） */
export const BRAND_LOGO_DARK = '/logo.png'

/** 浅色背景（登录卡片等） */
export const BRAND_LOGO_LIGHT = '/logo-light.png'

/** 浏览器标签 favicon */
export const BRAND_MARK = '/xinghe-logo.png'

export function brandLogoUrl(variant = 'dark') {
  const path = variant === 'light' ? BRAND_LOGO_LIGHT : BRAND_LOGO_DARK
  return `${path}?v=${BRAND_LOGO_VERSION}`
}

export function brandMarkUrl() {
  return `${BRAND_MARK}?v=${BRAND_LOGO_VERSION}`
}

export function adminDocumentTitle(pageTitle) {
  if (!pageTitle) return BRAND_ADMIN_TITLE
  return `${pageTitle} · ${BRAND_ADMIN_TITLE}`
}
